import { c as _c } from "react/compiler-runtime";
import { Memo, Show, reactive, useObservable } from '@legendapp/state/react';
import { batch } from '@legendapp/state';
import { Typography } from '@/components/Typography';
import { useLocationSelectState } from '@/components/forms/fields/LocationSelect/LocationSelectContext';
import { findSiteInRegion } from '@/services/rental-api-client';
import { type fieldOptions } from './LocationField';
import { LocationSelectList } from './LocationSelectList';
interface HorizontalLocationSelectListProps {
  pickUpField: fieldOptions;
  dropOffField: fieldOptions;
}
const ReactiveLocationSelectList = reactive(LocationSelectList);
export function HorizontalLocationSelectList(t0) {
  const $ = _c(17);
  const {
    pickUpField,
    dropOffField
  } = t0;
  const state$ = useLocationSelectState();
  let t1;
  if ($[0] !== state$.regions) {
    t1 = state$.regions.get();
    $[0] = state$.regions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const regions = t1;
  let t2;
  if ($[2] !== state$.dropOffLocation || $[3] !== state$.pickUpLocation || $[4] !== state$.selecting) {
    t2 = () => state$.selecting.get() === "pickUp" ? state$.pickUpLocation.get() : state$.dropOffLocation.get();
    $[2] = state$.dropOffLocation;
    $[3] = state$.pickUpLocation;
    $[4] = state$.selecting;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const activeValue$ = useObservable(t2);
  let t3;
  if ($[6] !== state$.variant) {
    t3 = () => state$.variant.get() === "horizontal";
    $[6] = state$.variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== activeValue$ || $[9] !== dropOffField || $[10] !== pickUpField || $[11] !== regions || $[12] !== state$) {
    t4 = () => <div className="border-base-125 rounded-tl-lg overflow-hidden rounded-br-2xl bg-base-150 w-0 peer-has-checked:w-93.75 transition-[width] duration-500"><div className="w-max flex flex-col gap-6 p-6 max-h-full"><Typography variant="paragraph-heavy" as="div"><Memo>{() => state$.selecting.get() === "pickUp" ? pickUpField.placeholder : dropOffField.placeholder}</Memo></Typography><div className="rounded-lg  border border-base-125 flex flex-col gap-4 flex-1 w-81 bg-white pb-4 overflow-auto scrollbar-primary scrollbar-thin" role="radiogroup" data-testid="location-select-list"><ReactiveLocationSelectList $name={() => state$.selecting.get() || ""} $regions={() => {
            const setting = state$.selecting.get();
            const pickUpCountry = state$.pickUpLocation.get()?.countryCode;
            if (setting === "dropOff" && pickUpCountry) {
              return regions.filter(region => region.countryCode === pickUpCountry);
            }
            return regions;
          }} $value={() => activeValue$.get()?.siteCode} onChange={e => batch(() => {
            const site = findSiteInRegion(regions, e.target.value);
            if (!site) {
              return;
            }
            state$.setActiveValue(site);
            const setting_0 = e.currentTarget.name as 'pickUp' | 'dropOff';
            if (!setting_0) {
              return;
            }
            if (setting_0 === "dropOff") {
              dropOffField.onChange?.(e);
              state$.selecting.delete();
              return;
            }
            pickUpField.onChange?.(e);
            const dropOff = state$.dropOffLocation.get();
            if (!dropOff?.siteCode) {
              state$.selecting.set("dropOff");
            } else {
              state$.selecting.delete();
            }
          })} /></div></div>{" "}</div>;
    $[8] = activeValue$;
    $[9] = dropOffField;
    $[10] = pickUpField;
    $[11] = regions;
    $[12] = state$;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <Show if={t3}>{t4}</Show>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}